export const qaItems = [
  {
    question: 'What kind of roles are you targeting? ',
    answer:
      'Senior full‑stack roles with ownership across UI, backend, and cloud delivery, including AI‑assisted development workflows. I also enjoy backend infrastructure and CI/CD when it strengthens product velocity and reliability.'
  },
  {
    question: 'What are your strongest technical strengths?',
    answer:
      'My strengths are full‑stack delivery (Java, Angular, Node/TypeScript), microservices architecture, and API integration, complemented by production‑grade CI/CD experience and a strong interest in AI‑assisted development.'
  },
  {
    question: 'What are your biggest recent wins?',
    answer:
      'Reduced patch cycles from 10 hours to 3 hours, automated audit prep from weeks to hours, and modernized 12+ enterprise apps to cut page‑load time by 35%.'
  },
  {
    question: 'What makes you different as an engineer?',
    answer:
      'I focus on measurable delivery improvements: automating release workflows, improving quality gates, and modernizing systems to reduce cycle time and defects.'
  },
  {
    question: 'What’s your stance on DevOps and platform work?',
    answer:
      'It’s an extension of my full‑stack work—not my sole focus. I collaborate on CI/CD and reliability when it improves product delivery and team velocity.'
  }
];
